module.exports = __webpack_public_path__ + "media/images/beige_map-6158ff2f.svg";